export class AccountModel {
  PrimaryID: number;
  UserID: number;
  CompanyBranchID: number;
  AccountCurrencyCode: string;
  ClientVendorTypeID: number;
  AccountTypeID: number;
  IsClient: boolean = true;
  IsPrincipal: boolean = false;
  IsSubSupplier: boolean = false;
  Name: string;
  FullName: string;
  ModificationDate: Date = new Date();
  Vat: string;
  IsActive: boolean;
  Email: string;
  ImgPath: string;
  LogoId: string;
  ContractualInfo: SupplierContractualInfo = new SupplierContractualInfo();
  MarketSegmentID: number;
  MarketSegmentIDs: number[] = [];
  Addresses: Address[] = [];
  ContactInfoList: any[] = [];
  ContactPersonList: any[] = [];
  registrationData: any[] = [];
  Selected: boolean;
  Comments: any[] = [];
  AccountManagerId: number;
}
export class Address {
  AddressID: number;
  AddressLine: string;
  CountryCode: string;
  CountryName: string;
  Destination: string;
  City: string;
  State: string;
  PostalCode: string;
  ZipCode: string;
  RowGuid: string;
  AddressTypeID: number;
  GovernateID: number;
  HasMarker: boolean = false;
  latitude: number;
  longitude: number;
  RelatedToID: number;
  RelatedTypeID: number;
  _RelatedToName: string;
}
export class SupplierContractualInfo {
  ContractInfoID: number;
  SupplierID: number;
  ExpiryDate: string;
  CancellationPeriod: number = 1;
  CancellationPeriodType: number = 4;
  CommissionType: number = 1;
  DoesAdvancePaymentRequireCommission: boolean = true;
  DoesFinalAcceptanceRequireCommission: boolean = true;
  Commission: number = 1;
  DecreasedTableList: any[] = [];
  Countries: any[] = [];
  Clients: any[] = [];
  MarketSegments: any[] = [];
}